<script setup lang="ts"></script>

<template>
  <div>CarFax</div>
</template>

<style scoped></style>
